// @flow
import * as React from 'react';
import CheckboxWrapper from './Checkbox.style';
import type { CheckboxProps } from './Checkbox.types';
import iconChecked from '../../../assets/icons/checkbox/checked.svg';
import iconUnchecked from '../../../assets/icons/checkbox/unchecked.svg';
import iconDisabled from '../../../assets/icons/checkbox/checked-partial-gray.svg';

const Checkbox = (props: CheckboxProps) => {
  const { selected, disabled = false, onSelect } = props;
  const icon = disabled ? iconDisabled : (selected ? iconChecked : iconUnchecked);
  return (
    <CheckboxWrapper
      onClick={() => !disabled && onSelect()}
    >
      <img
        className="Checkbox-icon"
        src={icon}
        alt=""
      />
    </CheckboxWrapper>
  );
};

export default Checkbox;
